import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import { useFirebaseUser } from 'utils/useFirebaseUser';
import {
  getCachedKey,
  getCachedKeyTime,
  updateCachedKeyTime,
  updateCachedKey,
} from 'utils/localforageHelpers';

export const useGodUser = () => {
  const { data: session }: any = useSession();
  const [isGod, setIsGod] = useState(false);
  const [loading, setLoading] = useState(true);
  const isAuthenticated = useFirebaseUser();
  useEffect(() => {
    const checkGodStatus = async () => {
      if (!session?.user?.email || session?.user?.data?.isAdmin !== true) {
        setIsGod(false);
        setLoading(false);
        return;
      }

      try {
        let isGod = false;
        isGod = await getCachedKey('isGod');
        const SEVEN_DAYS = 6.048e8; // 7 Days
        const lastTimeChecked = await getCachedKeyTime('isGodLastChecked');
        const dateTimeNow = new Date()?.getTime();
        const have7DaysPassed = dateTimeNow - lastTimeChecked >= SEVEN_DAYS;

        if (isGod !== null && isGod !== undefined && !have7DaysPassed) {
          setIsGod(isGod);
          setLoading(false);
          return;
        }

        const res = await fetch('/api/getGodUsers', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userEmail: session?.user?.email,
            isAdmin: session?.user?.data?.isAdmin ?? false,
          }),
        });

        const resJson = await res.json();
        isGod = resJson?.isGod;
        await updateCachedKey('isGod', isGod);
        await updateCachedKeyTime('isGodLastChecked', dateTimeNow);
        setIsGod(isGod);
      } catch (error) {
        console.error('Error fetching god users:', error);
        setIsGod(false);
      } finally {
        setLoading(false);
      }
    };

    if (session && isAuthenticated && session?.user?.email) {
      checkGodStatus();
    }
  }, [session, isAuthenticated]);

  return { isGod, loading };
};
